import React from 'react';

import { HorizontalContainer } from '@/components';
import { cn } from '@/lib/cn';

type SectionHeadingProps = {
    text: string;
    className?: string;
    rightElement?: React.ReactNode;
    onClick?: () => void;
};

export const SectionHeading = ({
    text,
    className,
    rightElement,
    onClick,
}: SectionHeadingProps) => {
    return (
        <HorizontalContainer
            onClick={onClick}
            className={cn('items-center justify-between', className)}
            spacing="none"
        >
            <h3>{text}</h3>
            {rightElement}
        </HorizontalContainer>
    );
};
